import React, { useState, useEffect } from 'react';
import { Location_img1, Location_img2, Location_img3, Location_img4, Location_img5, Location_img6 } from '../../../utils/ImagePath';

const ImageChange = () => {
  const images = [
    Location_img1,
    Location_img2,
    Location_img3,
    Location_img4,
    Location_img5,
    Location_img6
  ];


  const getRandomImage = () => {
    const randomIndex = Math.floor(Math.random() * images.length);
    return images[randomIndex];
  };

  const [currentImage, setCurrentImage] = useState(getRandomImage());

  useEffect(() => {
    setCurrentImage(getRandomImage());
  }, []);

  return (
    <>
      <img loading="lazy" src={currentImage} alt="Random Image" className='destination-update' />
    </>
  );
};

export default ImageChange;

